// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"37e45961","695":"8d2484b9","708":"41d8b0f1","787":"2fb80301","823":"a98ca23c"}[chunkId] + ".chunk.js";
};